import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "fx-notification",
  id: "fx-notification"
}
const _hoisted_2 = { class: "content-fx-notification" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"fx-notification__icon-wrapper\"><figure><svg width=\"63\" height=\"64\" viewBox=\"0 0 63 64\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"vuesax/bulk/direct-notification\"><g id=\"direct-notification\"><path id=\"Vector\" d=\"M49.875 21.375C54.2242 21.375 57.75 17.8492 57.75 13.5C57.75 9.15076 54.2242 5.625 49.875 5.625C45.5258 5.625 42 9.15076 42 13.5C42 17.8492 45.5258 21.375 49.875 21.375Z\" fill=\"#079F72\"></path><path id=\"Vector_2\" opacity=\"0.4\" d=\"M49.875 25.3125C43.365 25.3125 38.0625 20.01 38.0625 13.5C38.0625 11.61 38.5613 9.85125 39.3488 8.25H19.74C10.6837 8.25 5.25 13.6575 5.25 22.74V43.6087C5.25 52.7175 10.6837 58.125 19.74 58.125H40.6087C49.6912 58.125 55.0988 52.7175 55.0988 43.635V24.0263C53.5238 24.8138 51.765 25.3125 49.875 25.3125Z\" fill=\"#D3D3D3\"></path><path id=\"Vector_3\" d=\"M53.3925 33.765H44.7038C42.2625 33.765 40.0838 35.13 38.9813 37.2825L36.8813 41.43C36.3825 42.4275 35.385 43.0313 34.2825 43.0313H26.1187C25.3575 43.0313 24.2288 42.8738 23.52 41.4038L21.4463 37.2825C20.3438 35.1038 18.165 33.7388 15.7237 33.7388H6.9825C6.0375 33.765 5.25 34.5525 5.25 35.4975V43.6088C5.25 52.7175 10.6838 58.125 19.7663 58.125H40.6613C49.2188 58.125 54.495 53.4263 55.125 45.105V35.4975C55.125 34.5525 54.3375 33.765 53.3925 33.765Z\" fill=\"#079F72\"></path></g></g></svg></figure></div>", 1)
const _hoisted_4 = { class: "fx-notification__text" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "",
  id: "fx-notification-link"
}, "Ver mais", -1)

import notificationAudio from '@/assets/audio/notifications/notification.mp3';
import { viewNotification } from '@/global/states/ModalState';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FxNotification',
  setup(__props, { expose: __expose }) {

const notification = ref({
  title: '',
  body: ''
})

function show(title: string, body: string, href: string ) {
  notification.value = { title, body }

  document.getElementById('fx-notification')?.classList.add('open');
  (document.getElementById('fx-notification-link') as HTMLAnchorElement)!.href = href;

  const closeTimeout = setTimeout(() => {
    document.getElementById('fx-notification')?.classList.remove('open')
    clearTimeout(closeTimeout)
  }, 2000);

  const audio = new Audio(notificationAudio);
  audio.play();

  localStorage.setItem('newNotification', 'true');
  viewNotification(true);
}

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h6", null, _toDisplayString(notification.value.title), 1),
        _createElementVNode("p", null, _toDisplayString(notification.value.body), 1)
      ]),
      _hoisted_5
    ])
  ]))
}
}

})